<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" id="int" title="Introduction">
<p class="fmh1"><span class="right_1" epub:type="pagebreak" id="page_4" title="4"><a href="#/text/Contents#int"><b>Introduction</b></a></span></p>
<p class="noindent">Welcome to the <i>Brush Pen Lettering Practice Book.</i> I’m so glad you’re here! You may have just discovered the world of brush lettering, or maybe you’ve already started your journey and feel like you need some guidance along the way. Either way, you’re in the right place because this practice book will give you all the tips, drills, and exercises you need to make significant progress in the art of brush pen lettering.</p>
<p class="noindent1">This practice book is the companion workbook to the instructional guide <i>Brush Pen Lettering</i>. Just like the instructional guide, this practice book starts with the basics, and the various drills and exercises that follow increase with difficulty, helping you build your skills in a gradual way. The practice book will show you what to work on and in what order, so that instead of going about your practice haphazardly, you can spend your time truly honing your skills.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?3d908cd0